@if (labelCols(); as labelColumns) {
    <div class="row align-items-center">
        <label class="col-form-label" [class]="'col-' + labelColumns" [attr.for]="id || null">
            {{ label() }}
        </label>
        <div [class]="'col-' + (12 - labelColumns)">
            <ng-container [ngTemplateOutlet]="dropdown" />
        </div>
    </div>
} @else {
    @if (label() !== '') {
        <label class="form-label" [attr.for]="id || null">{{ label() }}</label>
    }
    <ng-container [ngTemplateOutlet]="dropdown" />
}

<ng-template #dropdown>
    <div ngbDropdown display="dynamic" placement="bottom-end bottom-start top-end top-start">
        <button
            type="button"
            class="btn btn-outline-primary w-100 text-start d-flex justify-content-between align-items-center gap-2"
            ngbDropdownToggle
            [class.is-invalid]="invalid()"
            [attr.id]="id || null"
            [disabled]="isDisabled"
            (blur)="markAsTouched()">
            <span
                class="text-truncate"
                [class.text-muted]="selectedLabel === undefined"
                [attr.title]="selectedLabel ?? null">
                {{ selectedLabel ?? placeholder }}
            </span>
            <i class="bi bi-chevron-down"></i>
        </button>
        <div ngbDropdownMenu class="w-100 overflow-y-auto" style="max-height: 300px">
            @for (item of data; track item[0]) {
                <button
                    type="button"
                    class="text-truncate"
                    ngbDropdownItem
                    [attr.title]="item[1]"
                    (click)="select(item[0])">
                    {{ item[1] }}
                </button>
            }
        </div>
    </div>
</ng-template>
